import type { DomainOpportunity } from '../../../../../common/api/domainOpportunities'

export type OpportunityOption = {
  key: string
  label: string
  link?: string
  stage?: string
  crmId?: string
  expectedRevenue?: {
    currency: string
    amount: number
  }
}

export type CrmOpportunityRecord = {
  Id?: string
  Name?: string
  StageName?: string
}

export const crmOpportunityToOption = (
  record: CrmOpportunityRecord,
  link?: string
): OpportunityOption | null => {
  const id = record.Id?.trim() || ''
  const name = record.Name?.trim() || ''
  if (!id && !name) return null
  return {
    key: id,
    label: name || id,
    ...(link ? { link } : {}),
    ...(record.StageName ? { stage: record.StageName } : {}),
    crmId: id,
  }
}

export const extractDomainFromWebsite = (
  website?: string | null
): string | null => {
  const trimmed = website?.trim()
  if (!trimmed) return null

  try {
    const withProtocol = /^https?:\/\//i.test(trimmed)
      ? trimmed
      : `https://${trimmed}`
    const hostname = new URL(withProtocol).hostname
      .replace(/^www\./i, '')
      .toLowerCase()
    return hostname || null
  } catch {
    return null
  }
}

export const getOpportunityDisplayLabel = (opportunity: {
  name?: string | null
  crm_id?: string | null
  id: string
}): string => {
  const name = opportunity.name?.trim()
  if (name) return name
  const crmId = opportunity.crm_id?.trim()
  if (crmId) return crmId
  return opportunity.id
}

export const getOpportunityMetaText = (opportunity: {
  stage?: string
}): string => opportunity.stage?.trim() || ''

export const flattenDomainOpportunities = (
  domains: Array<{
    opportunities?: Array<
      Pick<
        DomainOpportunity,
        'id' | 'name' | 'link' | 'stage' | 'crm_id' | 'expected_revenue'
      >
    >
  }>
): OpportunityOption[] =>
  domains.flatMap(domain =>
    (domain.opportunities || []).map(opportunity => ({
      key: opportunity.id,
      label: getOpportunityDisplayLabel(opportunity),
      link: opportunity.link,
      stage: opportunity.stage,
      crmId: opportunity.crm_id,
      expectedRevenue: opportunity.expected_revenue,
    }))
  )
